export const languageCodeWithoutLocal = (language: string | null | undefined) => {
    if (language) {
        return language.replace(/-.*/gm, "");
    }
    return "";
};

export const languageDescriptionWithoutLocal = (language: string | null | undefined) => {
    if (language) {
        return language.replace(/ \(.*/gm, "");
    }
    return "";
};
